/* global window */

export function hasDevToolsExtension () {
  return typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
}

export default function devToolsExtension () {
  return hasDevToolsExtension() ? window.devToolsExtension() : (f) => f
}

export function listenForReplays (middleware, store) {
  if (hasDevToolsExtension) {
    middleware.listenForReplays(store)
  }
}
